import styled, { css } from 'styled-components/macro'
import { Thread } from 'styles/misc'
import { mq } from 'styles/mq'

export const ImageWrapper = styled.div<{ $isExpanded?: boolean }>`
  margin: 0 auto;

  > div {
    position: relative;
    transition: 0.4s aspect-ratio;
    aspect-ratio: 793 / 613;
    overflow: hidden;
  }

  img {
    display: block;
    width: 100%;
  }

  ${mq.large} {
    width: min-content;

    img {
      width: auto;
    }
  }

  ${props =>
    !props.$isExpanded &&
    css`
      > div {
        aspect-ratio: 793 / 400;
        transition-delay: 0.4s;
      }
    `}

  &::before {
    ${Thread}
    left: 0;
    width: 100%;
    aspect-ratio: 793 / 80;
    transform: translateY(50%);
    mask-image: url("data:image/svg+xml,%3Csvg width='1440' height='132' viewBox='0 0 1440 132' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M-268 37.54C-258.66 91.22 -198.83 123.41 -144.35 122.64C-89.87 121.87 -39.08 97.12 11.31 76.39C61.7 55.66 117.47 38.35 169.98 52.91C219.37 66.6 258.23 106.61 307.65 120.21C430.74 154.09 544.27 14.43 671.3 27.07C739.23 33.83 795.97 83.36 862.89 96.84C928.74 110.1 995.73 87.21 1060.32 68.76C1124.91 50.32 1196.88 36.7 1257.1 66.45C1283.09 79.29 1304.91 99.43 1330.79 112.5C1413.2 154.12 1511.71 115.76 1595.7 77.43C1651.53 51.95 1707.35 26.48 1763.18 1' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
  }
`

export const SmallGraphics = styled.figure<{
  $largeSpacing?: boolean
  $centered?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem auto;
  max-width: 100%;
  text-align: center;

  ${mq.medium} {
    flex-direction: row-reverse;
    width: max-content;
    text-align: inherit;
    margin: 15rem auto;
  }
`

export const GraphicsDescription = styled.figcaption`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  ${mq.smallOnly} {
    * {
      line-height: 1.5;
    }
  }
  span {
    content: '';
    display: block;
    width: 1.6em;
    height: 1.6em;
    margin: 1rem;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: var(--theme-color);
  }

  ${mq.medium} {
    max-width: 24rem;
    flex-direction: row;
    gap: 3rem;
    font-size: 1.4rem;
  }
`

export const GraphicsImage = styled.img`
  display: block;
`
